const WORKFLOW86_EMAIL_SUFFIX = '@workflow86.com';

/** Staging builds set VITE_ALLOWED_USERS to activate the lockdown gate. */
export function isStagingLockdownActive() {
  return Boolean(import.meta.env.VITE_ALLOWED_USERS);
}

function normalizeIdentity(identity) {
  return (identity || '').trim().toLowerCase();
}

/** True when identity is on the explicit allowlist (legacy usernames, etc.). */
export function isExplicitStagingAllowlistIdentity(identity) {
  const allowedUsers = import.meta.env.VITE_ALLOWED_USERS;
  if (!allowedUsers) {
    return false;
  }
  const normalized = normalizeIdentity(identity);
  return allowedUsers
    .split(',')
    .map((entry) => entry.trim().toLowerCase())
    .filter(Boolean)
    .includes(normalized);
}

/** True for any @workflow86.com email or explicit allowlist entry. */
export function isAllowedStagingIdentity(identity) {
  if (!isStagingLockdownActive()) {
    return true;
  }
  const normalized = normalizeIdentity(identity);
  if (normalized.endsWith(WORKFLOW86_EMAIL_SUFFIX)) {
    return true;
  }
  return isExplicitStagingAllowlistIdentity(normalized);
}

export function stagingAccessDeniedMessage() {
  return 'Access restricted. Staging is limited to @workflow86.com accounts and authorized test users.';
}

export function stagingSignupDeniedMessage() {
  return 'Staging sign-up is limited to @workflow86.com work emails.';
}
